import { ColorEnum } from '@/constants/color'
import KeyboardAvoider, {
    KeyboardAvoiderVariant,
} from '@/features/ui/components/Modal/parts/KeyboardAvoider'
import { FC, ReactNode } from 'react'
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native'
import { UnistylesVariants, createStyleSheet, useStyles } from 'react-native-unistyles'

type ModalProps = UnistylesVariants<typeof stylesheet> & {
    children: ReactNode
    backdropStyle?: StyleProp<ViewStyle>
    contentStyle?: StyleProp<ViewStyle>
    avoidKeyboard?: boolean
    collapsable?: boolean
    keyboardAvoidanceVariant?: KeyboardAvoiderVariant
    keyboardVerticalOffset?: number
    respectTopSafeArea?: boolean
}

const Modal: FC<ModalProps> = ({
    children,
    contentVariant = 'normal',
    backdropStyle,
    contentStyle,
    avoidKeyboard = false,
    collapsable = true,
    keyboardAvoidanceVariant = 'position',
    keyboardVerticalOffset,
    respectTopSafeArea = false,
}) => {
    const { styles } = useStyles(stylesheet, { contentVariant })

    const contentView = <View style={[styles.content, contentStyle]}>{children}</View>

    return (
        <View
            collapsable={collapsable}
            style={[
                styles.backdrop,
                respectTopSafeArea && styles.backdropTopSafeArea,
                backdropStyle,
            ]}
        >
            {avoidKeyboard ? (
                <KeyboardAvoider
                    variant={keyboardAvoidanceVariant}
                    keyboardVerticalOffset={keyboardVerticalOffset}
                >
                    {contentView}
                </KeyboardAvoider>
            ) : (
                contentView
            )}
        </View>
    )
}

const paddingVertical = 16

const stylesheet = createStyleSheet((_, { insets }) => ({
    backdrop: {
        ...StyleSheet.absoluteFillObject,
        paddingTop: paddingVertical,
        paddingBottom: paddingVertical + insets.bottom,
        backgroundColor: 'rgba(0, 0, 0, 0.33)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    backdropTopSafeArea: {
        paddingTop: paddingVertical + insets.top,
    },
    content: {
        backgroundColor: ColorEnum.GRAY_100,
        maxHeight: '100%',
        maxWidth: '93%',
        borderRadius: 16,
        variants: {
            contentVariant: {
                normal: {
                    width: 327,
                },
                wide: {
                    width: '93%',
                },
            },
        },
    },
}))

export default Modal
